import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { organizationService } from '@services/organization';
import { Organization } from '@models/organization.model';

export const useOrganization = (
  organizationId: string | null,
): UseQueryResult<Organization, Error> => {
  return useQuery({
    queryKey: ['organizations', organizationId],
    queryFn: () => organizationService.getOrganization(organizationId!),
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
